import {useEffect, useState} from 'react';

export const useIovationFingerprint = () => {
  const [deviceFingerprint, setDeviceFingerprint] = useState<string | null>(
    null,
  );

  useEffect(() => {
    let timeout: number;
    if (!deviceFingerprint) {
      timeout = window.setInterval(() => {
        const blackbox: FingerPrintResult | undefined =
          window.IGLOO && window.IGLOO.getBlackbox
            ? window.IGLOO.getBlackbox()
            : undefined;
        if (blackbox && blackbox.finished) {
          setDeviceFingerprint(blackbox.blackbox);
          clearTimeout(timeout);
        }
      }, 300);
    }

    return () => {
      clearInterval(timeout);
    };
  }, [deviceFingerprint]);

  return deviceFingerprint;
};
